import React, {useState} from "react";
import {observer} from "mobx-react";
import * as formik from "formik";
import * as yup from "yup";
import Form from "react-bootstrap/Form";
import {Badge, Card, Col, Container, InputGroup, Row} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import {taxAuthApi} from "../../../api/taxAuth.js";
import provList from "../../../_helpers/provList.js";
import HeroSection from "../../../components/HeroSection.jsx";

function InviteTaxAuthPage() {

    const [pageState,setPageState] = useState({
        formSubmitted: false
    });

    const { Formik } = formik;
    const schema = yup.object().shape({
        taxAuthorityName: yup.string().required('Tax Authority Name is required'),
        inviteeFirstName: yup.string().required('First Name is required'),
        inviteeLastName: yup.string().required('Last Name is required'),
        inviteeEmailAddress: yup.string().required('Email is required').email('Invalid email format'),
        taxAuthCode: yup.string().required('Tax Authority code is required'),
        stripeBusinessType: yup.string().required('Business Type is required'),
    });

    if (pageState.formSubmitted){
        return (
            <Container className="dashboard-shell">
                <HeroSection
                    accent="admin"
                    eyebrow="Invite"
                    title="Registration Submitted"
                    subtitle="We sent an email to confirm and activate the account."
                />
            </Container>
        )
    } else {
        return (
            <Container className="dashboard-shell">
                <HeroSection
                    accent="admin"
                    eyebrow="Invite"
                    title="Invite Tax Authority"
                    subtitle="Send an onboarding invitation to a municipality."
                />
                <Card className="dashboard-panel mt-4">
                    <Card.Body>
                        <Formik
                            validationSchema={schema}
                            onSubmit={async (values, { setSubmitting }) => {
                                try {
                                    setSubmitting(true);
                                    taxAuthApi.inviteTaxAuth(values.taxAuthorityName, values.taxAuthCode, values.inviteeFirstName,
                                        values.inviteeLastName, values.inviteeEmailAddress, values.stripeBusinessType);
                                } finally {
                                    setSubmitting(false);
                                    setPageState(prevState => {
                                        return {...prevState, formSubmitted : true}
                                    });
                                }

                            }}
                            initialValues={{
                                taxAuthorityName : '',
                                inviteeFirstName: '',
                                inviteeLastName: '',
                                inviteeEmailAddress: '',
                                taxAuthCode: '',
                                stripeBusinessType: 'company',
                            }}
                        >
                            {({ handleSubmit, handleChange, touched, values, isSubmitting, errors }) => (
                                <Form noValidate onSubmit={handleSubmit}>
                                    <Row className="mb-3">
                                        <Form.Group as={Col} md="4" controlId="taxAuthorityName">
                                            <Form.Label>Tax Authority Name</Form.Label>
                                            <InputGroup hasValidation>
                                                <Form.Control
                                                    type="text"
                                                    name="taxAuthorityName"
                                                    value={values.taxAuthorityName}
                                                    onChange={handleChange}
                                                    isInvalid={touched.taxAuthorityName && !!errors.taxAuthorityName}
                                                />
                                                {touched.taxAuthorityName && (<Form.Control.Feedback type="invalid">
                                                    {errors.taxAuthorityName}
                                                </Form.Control.Feedback>)}
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} md="4" controlId="taxAuthCode">
                                            <Form.Label>Tax Authority Code</Form.Label>
                                            <InputGroup hasValidation>
                                                <Form.Control
                                                    type="text"
                                                    name="taxAuthCode"
                                                    value={values.taxAuthCode}
                                                    onChange={handleChange}
                                                    isInvalid={touched.taxAuthCode && !!errors.taxAuthCode}
                                                />
                                                {touched.taxAuthCode && (<Form.Control.Feedback type="invalid">
                                                    {errors.taxAuthCode}
                                                </Form.Control.Feedback>)}
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} md="4" controlId="stripeBusinessType">
                                            <Form.Label>Stripe Business Type</Form.Label>
                                            <Form.Select
                                                aria-label="stripeBusinessType"
                                                name={"stripeBusinessType"}
                                                value={values.stripeBusinessType}
                                                onChange={handleChange}
                                                isInvalid={touched.stripeBusinessType && !!errors.stripeBusinessType}
                                            >
                                                <option key="company" value="company">Company</option>
                                                <option key="individual" value="individual">Individual</option>
                                                <option key="non_profit" value="non_profit">Non-Profit</option>

                                            </Form.Select>
                                            {touched.stripeBusinessType && (<Form.Control.Feedback type="invalid">
                                                {errors.stripeBusinessType}
                                            </Form.Control.Feedback>)}
                                        </Form.Group>
                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Group as={Col} md="4" controlId="inviteeFirstName">
                                            <Form.Label>Invitee First Name</Form.Label>
                                            <InputGroup hasValidation>
                                                <Form.Control
                                                    type="text"
                                                    name="inviteeFirstName"
                                                    value={values.inviteeFirstName}
                                                    onChange={handleChange}
                                                    isInvalid={touched.inviteeFirstName && !!errors.inviteeFirstName}
                                                />
                                                {touched.inviteeFirstName && (<Form.Control.Feedback type="invalid">
                                                    {errors.inviteeFirstName}
                                                </Form.Control.Feedback>)}
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} md="4" controlId="inviteeLastName">
                                            <Form.Label>Invitee Last Name</Form.Label>
                                            <InputGroup hasValidation>
                                                <Form.Control
                                                    type="text"
                                                    name="inviteeLastName"
                                                    value={values.inviteeLastName}
                                                    onChange={handleChange}
                                                    isInvalid={touched.inviteeLastName && !!errors.inviteeLastName}
                                                />
                                                {touched.inviteeLastName && (<Form.Control.Feedback type="invalid">
                                                    {errors.inviteeLastName}
                                                </Form.Control.Feedback>)}
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} md="4" controlId="inviteeEmailAddress">
                                            <Form.Label>Invitee Email Address</Form.Label>
                                            <InputGroup hasValidation>
                                                <Form.Control
                                                    type="text"
                                                    name="inviteeEmailAddress"
                                                    value={values.inviteeEmailAddress}
                                                    onChange={handleChange}
                                                    isInvalid={touched.inviteeEmailAddress && !!errors.inviteeEmailAddress}
                                                />
                                                {touched.inviteeEmailAddress && (<Form.Control.Feedback type="invalid">
                                                    {errors.inviteeEmailAddress}
                                                </Form.Control.Feedback>)}
                                            </InputGroup>
                                        </Form.Group>
                                    </Row>

                                    <Button type="submit" disabled={isSubmitting}>Send Invitation</Button>
                                </Form>
                            )}
                        </Formik>
                    </Card.Body>
                </Card>
            </Container>
        )
    }
}

export default observer(InviteTaxAuthPage);
